import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class InitSetupService extends DatabaseGwService {
  URL_PATH: string = "/init-setup";
}
